import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    CircularProgress,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Chip,
    IconButton,
    Menu,
    MenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { getAllExtraFees } from "../../Apis/DeliveryPriceApi";

const ExtraFeeManagement = () => {
    const [extraFees, setExtraFees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentFee, setCurrentFee] = useState(null);

    const navigate = useNavigate();

    // Fetch all extra fees
    const fetchExtraFees = async () => {
        try {
            setLoading(true);
            const response = await getAllExtraFees();
            if (response && response.extraFees) {
                setExtraFees(response.extraFees);
            }
            setError(null);
        } catch (err) {
            console.error(err);
            setError("Failed to fetch extra fees.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchExtraFees();
    }, []);

    // Normalize status
    const normalizeStatus = (val) => val === true || val === "true" || val === 1 || val === "1";
    const getStatusLabel = (val) => (normalizeStatus(val) ? "Active" : "Inactive");

    // Menu handlers
    const handleMenuOpen = (event, fee) => {
        setAnchorEl(event.currentTarget);
        setCurrentFee(fee);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    // Navigate to edit page
    const handleEditClick = (feeId) => {
        navigate(`/extra-fees/edit/${feeId}`);
        handleMenuClose();
    };

    return (
        <Box sx={{ padding: 3, width: "90%", margin: "auto" }}>
            <Typography variant="h4" gutterBottom>
                Extra Fees Management
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Typography color="error" sx={{ textAlign: "center" }}>
                    {error}
                </Typography>
            ) : extraFees.length > 0 ? (
                <TableContainer component={Paper} sx={{ mt: 3 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>S.no</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>Amount</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {extraFees.map((fee, index) => (
                                <TableRow key={fee.id}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{fee.type}</TableCell>
                                    <TableCell>₹{fee.amount}</TableCell>
                                    <TableCell>
                                        <Chip
                                            label={getStatusLabel(fee.status)}
                                            color={normalizeStatus(fee.status) ? "success" : "error"}
                                            size="small"
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <IconButton onClick={(e) => handleMenuOpen(e, fee)}>
                                            <MoreVertIcon />
                                        </IconButton>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl) && currentFee?.id === fee.id}
                                            onClose={handleMenuClose}
                                        >
                                            <MenuItem onClick={() => handleEditClick(fee.id)}>Edit</MenuItem>
                                        </Menu>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <Typography sx={{ textAlign: "center" }}>No extra fees found.</Typography>
            )}
        </Box>
    );
};

export default ExtraFeeManagement;
